import { chromeExtensionId } from 'helpers/constants';

export const setIntervalX = (fn: any, delay: any, times: any) => {
  if (!times) return;

  setTimeout(() => {
    fn();
    setIntervalX(fn, delay, times - 1);
  }, delay);
};

export const openGroupLoginInExtension = (groupId: string) => {
  window.location.href =
    'chrome-extension://' + chromeExtensionId + '/index.html#/app/group-invite/' + groupId;
};
